var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { staticClass: "mx-0 px-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "pt-2", attrs: { justify: "space-between" } },
        [
          _c("v-card-subtitle", [
            _vm._v(
              " View files maintained (stored) in the Heimdall Server backend database. "
            ),
          ]),
          _c(
            "v-btn",
            {
              staticClass: "mr-8 ml-2 mt-2",
              staticStyle: { cursor: "pointer" },
              attrs: { icon: "", small: "" },
              on: {
                click: function ($event) {
                  _vm.isActiveDialog = true
                },
              },
            },
            [
              _c(
                "v-icon",
                {
                  attrs: {
                    "b-tooltip.hover": "",
                    title: "Search Instructions",
                    color: "primary",
                  },
                },
                [_vm._v(" mdi-information-outline ")]
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", width: "500" },
              model: {
                value: _vm.isActiveDialog,
                callback: function ($$v) {
                  _vm.isActiveDialog = $$v
                },
                expression: "isActiveDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [_vm._v("Search Instructions")]),
                  _c(
                    "v-card-text",
                    [
                      _vm._v(
                        ' Values to be search don\'t need to match exactly, if searching for a file name "compliant_audit_scan.nessus", the input value can be any part of the name. This applies to all fields regardless of the logic selected. When searching for a Tag value, the search return includes all tags associated with the matching evaluation. Search logic can be inclusive or exclusive. The following table provides the expected outcomes base on the logic selected. '
                      ),
                      _c("v-simple-table", {
                        attrs: { "fixed-header": "" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function () {
                              return [
                                _c("thead", [
                                  _c("tr", [
                                    _c(
                                      "th",
                                      { staticClass: "text-left text-h6" },
                                      [_vm._v("Logic")]
                                    ),
                                    _c(
                                      "th",
                                      { staticClass: "text-left text-h6" },
                                      [_vm._v("Outcome")]
                                    ),
                                  ]),
                                ]),
                                _c("tbody", [
                                  _c("tr", [
                                    _c("td", [_vm._v("AND")]),
                                    _c("td", [
                                      _vm._v(
                                        " Values provided in the search fields (file, group, or tag name) are logically inclusive, there is, all field values provided must be evaluated to true for a record to be returned. "
                                      ),
                                    ]),
                                  ]),
                                  _c("tr", [
                                    _c("td", [_vm._v("OR")]),
                                    _c("td", [
                                      _vm._v(
                                        " Values provided in the search fields (file, group, or tag name) are not logically inclusive, there is, any value provided evaluates to true, records matching the field value provided are returned. "
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                      _c("br"),
                      _c("b", [_vm._v("NOTE:")]),
                      _vm._v(
                        " To clear the search fields, either click the clear icon (X) or delete any value(s) and press the enter (return) key. "
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function ($event) {
                              _vm.isActiveDialog = false
                            },
                          },
                        },
                        [_vm._v("Close Dialog")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("LoadFileList", {
        attrs: {
          headers: _vm.headers,
          "evaluations-loaded": _vm.pagedEvaluations,
          loading: _vm.queryingRecords,
          "total-items-per-page": _vm.itemsPerPage,
          "evaluations-count": _vm.evaluationsCount,
        },
        on: {
          "load-selected": function ($event) {
            return _vm.load_results($event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }